// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"fb8796b0","525":"2acd0166","537":"fde985ac","588":"f0289784","825":"3f0b1586","834":"b602d9c8","950":"6b79ad50"}[chunkId] + ".chunk.css";
};